"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validImpressionsMode = void 0;
var constants_1 = require("../../logger/constants");
var constants_2 = require("../constants");
var lang_1 = require("../lang");
function validImpressionsMode(log, impressionsMode) {
    impressionsMode = (0, lang_1.stringToUpperCase)(impressionsMode);
    if ([constants_2.DEBUG, constants_2.OPTIMIZED, constants_2.NONE].indexOf(impressionsMode) > -1)
        return impressionsMode;
    log.error(constants_1.ERROR_INVALID_CONFIG_PARAM, ['impressionsMode', [constants_2.DEBUG, constants_2.OPTIMIZED, constants_2.NONE], constants_2.OPTIMIZED]);
    return constants_2.OPTIMIZED;
}
exports.validImpressionsMode = validImpressionsMode;
